<template>
  <div class="container">
    <!-- 功能 -->
    <div class="table-container">
      <div class="table-action-row">
        <div class="table-action-form">
          <!-- <el-input
            class="form-item"
            v-model="sandBoxSearch.sandbox_name"
            clearable
            placeholder="请输入名称"
            @input="handleChange"
          >
            <i slot="suffix" class="el-input__icon iconfont icon-search"></i>
          </el-input>
          <el-button @click="handleReset">重 置</el-button> -->
        </div>
        <div class="table-action-button">
          <el-button
            v-if="jurisdiction.aiAgentAiModelManagement_agent_systemModelSetting"
            type="primary"
            @click="toAdd"
          >
            系统模型设置
          </el-button>
          <!-- <el-button type="info" @click="deployVisible = true">模型导入</el-button> -->
        </div>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" ref="list" v-loading="loading">
      <el-table-column prop="provider_name" label="供应商"></el-table-column>
      <el-table-column prop="metadata" label="metadata"></el-table-column>
      <el-table-column prop="added" label="是否已添加"></el-table-column>
      <el-table-column prop="enabled" label="enabled"></el-table-column>
      <el-table-column fixed="right" label="操作" width="500">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.added === '是'"
            class="text-button"
            type="text"
            @click="toModelList(scope.row)"
          >
            查看模型列表
          </el-button>
          <el-button
            v-if="scope.row.added === '是' && jurisdiction.aiAgentAiModelManagement_agent_delete"
            class="text-button"
            type="text"
            @click="toDelete(scope.row)"
          >
            移除
          </el-button>
          <!-- <el-button
            v-if="scope.row.added === '是'"
            class="text-button"
            type="text"
            @click="toModelList(scope.row)"
          >
            设置APIKey
          </el-button> -->
          <el-button
            v-if="scope.row.added === '否' && jurisdiction.aiAgentAiModelManagement_agent_add"
            class="text-button"
            type="text"
            @click="addProvider(scope.row)"
          >
            新增
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 设置默认模型-->
    <providerDefaultSetting
      :visible="settingVisible"
      @close="settingVisible = false"
      @refresh="refresh"
    />
    <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    ></el-pagination> -->
  </div>
</template>

<script>
import providerDefaultSetting from '../components/providerDefaultSetting.vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
export default {
  components: {
    providerDefaultSetting,
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      tableData: [],

      // 加载状态
      loading: false,
      sandboxTypes: [
        { label: ' 待执行', value: ' 0' },
        { label: '执行中', value: '2' },
        { label: '已完成', value: '3' },
        { label: '失败', value: '4' },
        { label: '部分失败', value: '5' },
      ],
      sandboxStatus: [
        { label: ' 待执行', value: '0' },
        { label: '执行中', value: '2' },
        { label: '已完成', value: '3' },
        { label: '失败', value: '4' },
        { label: '部分失败', value: '5' },
      ],
      // 搜索表单
      sandBoxSearch: {
        sandbox_name: '',
        sandbox_type: '',
        task_status: '',
        create_time: '',
        update_time: '',
        update_by: '',
      },
      // 新建窗口展示
      settingVisible: false,
      // 模型文件部署
      deployVisible: false,
      detailVisible: false,
      cloneVisible: false,
      operateType: '',
      rowMessage: {},
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'aiAgentAiModelManagement_agent_systemModelSetting',
        'aiAgentAiModelManagement_agent_delete',
        'aiAgentAiModelManagement_agent_add',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
  },
  watch: {},
  created() {
    this.getList();
    // 'pppp'
    // console.log("%c Line:313 🥥 'pppp'", 'color:#2eafb0', 'pppp');
  },
  methods: {
    toModelList(rowMessage) {
      // rowMessage.provider_name
      console.log(
        '%c Line:230 🍐 rowMessage.provider_name',
        'color:#ffdd4d',
        rowMessage.provider_name,
      );
      this.$router.push({
        name: 'ai-model-sub-list',
        query: {
          provider_name: rowMessage.provider_name,
        },
      });
    },

    toAdd() {
      this.operateType = 'add';
      this.settingVisible = true;
    },

    addProvider(row) {
      // row
      console.log('%c Line:268 🥚 row', 'color:#f5ce50', row);
      const params = {
        provider_name: row.provider_name,
        credentials: '{}',
      };
      this.$request({
        url: this.$api.aiAddProvider,
        data: params,
      }).then((res) => {
        console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
        this.refresh();
      });
    },

    toDelete(row) {
      console.log('%c Line:268 🥚 row', 'color:#f5ce50', row);
      const params = {
        provider_name: row.provider_name,
      };
      this.$request({
        url: this.$api.aiDeleteProvider,
        data: params,
      }).then((res) => {
        console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
        this.refresh();
      });
    },

    refresh() {
      this.resetPage();
      this.getList();
    },

    // 获取列表数据
    getList() {
      this.loading = true;
      console.log('%c Line:263 🍺 this.sandBoxSearch)', 'color:#465975', this.sandBoxSearch);
      const params = {};
      if (this.sandBoxSearch.sandbox_name) {
        params.sandbox_name = this.sandBoxSearch.sandbox_name;
      }
      if (this.sandBoxSearch.sandbox_type) {
        params.sandbox_type = this.sandBoxSearch.sandbox_type;
      }
      if (this.sandBoxSearch.task_status) {
        params.task_status = Number(this.sandBoxSearch.task_status);
      }
      if (this.sandBoxSearch.update_by) {
        params.update_by = this.sandBoxSearch.update_by;
      }
      return this.$request({
        url: this.$api.aiListProviders,
        data: {
          // offset: (this.pageIndex - 1) * this.pageSize,
          // limit: this.pageSize,
          // ...params,
        },
      })
        .then((res) => {
          // res
          console.log('%c Line:261 🍊 res', 'color:#7f2b82', res);
          const computedList = res.providers
            .sort((a, b) => {
              return (b.added === true) - (a.added === true);
            })
            .map((item) => ({
              ...item,
              added: item.added ? '是' : '否',
              enabled: item.enabled ? '是' : '否',
            }));
          this.tableData = computedList;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 表单查询
    handleChange: _.debounce(function () {
      this.refresh();
    }, 1000),

    handleReset() {
      this.resetPage();
      this.refresh();
    },

    resetPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    },
    // 分页器
    handleSizeChange(value) {
      this.pageIndex = 1;
      this.pageSize = value;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/pagination.scss';
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/tab.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/dropdown.scss';

.container {
  display: flex;
  flex-direction: column;
}
.top-tab {
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 16px;
  padding-right: 16px;
}
.table-container {
  flex: 1;
  margin: 16px 0;
  padding: 16px;
  background: #fff;
  .table-action-row {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    .table-action-form {
      flex: 1;
      display: flex;
      flex-flow: wrap;
      .form-item {
        width: 240px;
        margin-right: 18px;
      }
    }
  }
  .text-button {
    margin-right: 15px;
  }
  .danger-action {
    color: #e34d59;
  }
}
.status-icon {
  margin-bottom: -3px;
  margin-right: 4px;
}
.time {
  ::v-deep .el-input__inner {
    padding-left: 30px;
  }
}
</style>
